import { render, staticRenderFns } from "./Etalon.vue?vue&type=template&id=10b7587b&"
import script from "./Etalon.vue?vue&type=script&lang=js&"
export * from "./Etalon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports